<template>
  <div class="password">
    <BaseInput
      v-model="password"
      v-bind="$attrs"
      v-on="$listeners"
      :type="!isPasswordVisible ? 'password' : 'text' "
      :label="inputLabel"
      :hasError="inputHasError"
      :errorMessage="passwordErrorMessage"
      hasIcon
      @input="handleInput"
    />

    <div class="password__toggle">
      <button
        type="button"
        tabindex="-1"
        class="password__toggle--button"
        @click.prevent="togglePasswordVisibility"
      >
        <svg class="password__toggle--icon">
          <use :xlink:href="`/images/svg-symbols.svg${isPasswordVisible ? '#eye-close' : '#eye-open'}`"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import BaseInput from "commons/js/components/atoms/BaseInput";

export default {
  inheritAttrs: false,

  components: {
    BaseInput
  },

  props: {
    inputHasError: {
      type: Boolean,
      default: false,
    },

    inputLabel: {
      type: String,
      required: true
    },

    passwordErrorMessage: {
      type: String
    }
  },

  data() {
		return {
      password: '',
			isPasswordVisible: false
		}
  },

  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    handleInput() {
      this.$nextTick(() => {
        this.$emit('input', this.password)
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.password
  position relative
  height 85px

  &__toggle
    position absolute
    right 0
    bottom 0
    z-index 2

    &--button
      padding 0
      margin 0
      border none
      background transparent

    &--icon
      width 30px
      height 30px
      border none
      background transparent
      cursor pointer
      fill #3598dc
</style>
